// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedUserInteractionSchema = z.enum(['X','N','R','P','A'] as const);

export type CvssModifiedUserInteractionType = `${z.infer<typeof CvssModifiedUserInteractionSchema>}`

export default CvssModifiedUserInteractionSchema;
